// @ts-check

import { api as locationPageApi } from '../locationPageActions.js';
import * as toolsService from '../../../services/Tools/toolsService';
import { gridsNames } from '../../../enums/gridsNames';
import * as gridActionsHelper from '../../../../../infrastructure/js/components/Grid/Utils/gridActionsHelper';
import DateTimeHelper from '../../../../../infrastructure/js/utils/dateTimeHelper';



/**
 * @typedef {import('../../../types/ServerTypes/Models/Data.js').ToolResponseModel} ToolResponseModel
 *
 */

const gridActions = gridActionsHelper.getGridActions(gridsNames.LOCATION_ASSET_TOOLS, _fetchDataAction, _convertToRowData);

function _fetchDataAction(query) {
  return function (dispatch, getState) {
    let locationId = locationPageApi.getLocationId(dispatch, getState)();
    return toolsService.getToolsDataByStationId(locationId, query);
  }
}

/**
 * @param {ToolResponseModel[]} rows
 * @param {number} serverTimeSeconds
 */
function _convertToRowData(rows, serverTimeSeconds) {

  let items = rows.map((x) => {

    x.cyclesCount = (x.maxNumOfCycles !== null) ? (x.maxNumOfCycles - (x.maxNumOfCycles - x.currentCyclesNumber)) : null;
    x.m_maintenanceUsageTime = DateTimeHelper.ConvertMinutesToDaysHoursMinutes(x.maintenanceUsageTime);
    x.m_maintenanceRemainingUsageTime = DateTimeHelper.ConvertMinutesToDaysHoursMinutes(x.maintenanceRemainingUsageTime);

    if (x.lastOperation) {
      x.lastOperation.m_time =
        x.lastOperation.createdDate ? DateTimeHelper.FormatDateObjectToRelativeTime(x.lastOperation.createdDate, serverTimeSeconds) : null;
    }


    x.m_maintenanceData = _createMaintenanceData(x);

    return x;
  });

  return items;
}


/**
 * @param {ToolResponseModel} tool
 */
function _createMaintenanceData(tool) {

  // console.log('tool ===> ', tool);

  let type = tool.toolType.maintenanceType;

  // Temporary workaround for server logic having default TIME_BASED type for no maintenance tools.
  if (type === "TIME_BASED" && tool.maintenanceIntervalTime === null) {
    type = null;
  }

  return {

    type: type,

    timeBased: {

      elapsedMinutes: tool.maintenanceIntervalTime, // X
      remainingMinutes: tool.maintenanceRemainingIntervalTime, // Y
      totalMinutes: tool.maintenanceIntervalTime + tool.maintenanceRemainingIntervalTime,

      percentRemaining: 100 - _calculatePercentUsed(tool.maintenanceIntervalTime, tool.maintenanceRemainingIntervalTime),
      nextMaintenanceDate: tool.nextMaintenanceDueDate

    },

    usageBased: {

      remainingMinutes: tool.maintenanceRemainingUsageTime, // X
      completedMinutes: tool.completedUsageTime, // Y
      startedMinutes: tool.startedUsageTime, // Z
      scheduledMinutes: tool.scheduledUsageTime, // W

      elapsedMinutes: tool.maxManufactureUsageTime - tool.maintenanceRemainingUsageTime,
      totalMinutes: tool.maxManufactureUsageTime,
      percentRemaining: 100 - _calculatePercentUsed(tool.maxManufactureUsageTime - tool.maintenanceRemainingUsageTime, tool.maintenanceRemainingUsageTime),

      nextMaintenanceDate: tool.nextMaintenanceDueDate

    },


    cycleBased: {

      remainingCycles: tool.maintenanceRemainingCycles, // X
      completedCycles: tool.completedCyclesNumber, // Y
      startedCycles: tool.startedCyclesNumber, // Z
      scheduledCycles: tool.scheduledCyclesNumber, // W

      elapsedCycles: tool.maxNumOfCycles - tool.maintenanceRemainingCycles,
      totalCycles: tool.maxNumOfCycles,

      percentRemaining: 100 - _calculatePercentUsed(tool.maxNumOfCycles - tool.maintenanceRemainingCycles, tool.maintenanceRemainingCycles),

      nextMaintenanceDate: tool.nextMaintenanceDueDate

    }


  };

}


/**
 * @param {number} elapsed
 * @param {number} remaining
 */
function _calculatePercentUsed(elapsed, remaining) {
  let total = elapsed + remaining;

  if (total === 0) {
    return 0;
  }

  if (remaining === 0) {
    return 100;
  }

  let percentExact = (elapsed / total) * 100;
  let percentRounded = Math.round(percentExact);

  // Ensure at least 1% is shown if there is any usage
  if (percentRounded === 0 && percentExact > 0) {
    return 1;
  }

  return percentRounded;
}



export let actionTypes = gridActions.actionTypes, api = gridActions.apiActions, jsxActions = gridActions.jsxActions;


